import { css } from 'emotion';

import { touchTargetHeightPadding } from '../../mixins';
import { h4, h5, text } from '../../fontSizes';
import { minWidth, tablet, desktopMedium } from '../../screenSizes';
import { bright } from '../../colors';

export const defaultLink = css`
  color: ${bright};
  ${touchTargetHeightPadding(text)};

  &:hover,
  &:hover:focus,
  &:focus,
  &:active:hover,
  &:active,
  &:active:focus {
    color: ${bright};
    text-decoration: none;
  }

  ${minWidth(tablet)} {
    font-size: ${h5};

    ${touchTargetHeightPadding(h5)};
  }

  ${minWidth(desktopMedium)} {
    font-size: ${h4};
    ${touchTargetHeightPadding(h4)};
  }
`;



// WEBPACK FOOTER //
// ./app/components/Navigation/defaultLink.js